export interface ThreadMessage {
  threadId: number;
  text: string;
  selectedMessageTemplateId: number | undefined;
}

export enum ScoutCommentStorageKey {
  Standard = "scoutComments",
  Agent = "scoutAgentComments"
}
